<template>
  <div>
    <span v-if="queue">{{ $t('generating') }} {{ queue.progress }}%</span>
    <v-btn
      v-else
      icon
      @click="download">
      <v-icon>cloud_download</v-icon>
    </v-btn>
  </div>
</template>

<script>
import TimesheetApi from '@/api/TimesheetApi'
import CompanyApi from '@/api/CompanyApi'

export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },

  data: () => ({
    queue: null,
    queueInterval: null,
    isQueueGet: false
  }),

  methods: {
    async download () {
      const { month } = this.item
      const [mm, yyyy] = month.split('-')

      try {
        this.queue = await TimesheetApi.downloadTimesheetsOfMonth(
          `${yyyy}-${mm}`
        )
      } catch (e) {
        this.$notification(e)
      }

      this.queueInterval = setInterval(async () => {
        if (this.isQueueGet) return
        try {
          this.isQueueGet = true
          this.queue = await CompanyApi.getQueue(this.queue.id)
          if (this.queue.is_finished) {
            await CompanyApi.downloadQueue(this.queue.id, `${yyyy}-${mm}`)
            this.queue = null
            clearInterval(this.queueInterval)
          }
          this.isQueueGet = false
        } catch (e) {
          this.$notification(e)
          this.queue = null
          clearInterval(this.queueInterval)
          this.isQueueGet = false
        }
      }, 1000)
    }
  },

  destroyed () {
    clearInterval(this.queueInterval)
  },

  i18n: {
    messages: {
      de: {
        generating: 'Erstellen...'
      },
      en: {
        generating: 'Generating...'
      },
      tr: {
        generating: 'Yaratma...'
      },
      ru: {
        generating: 'Генерация...'
      }
    }
  }
}
</script>
